module.exports = __webpack_public_path__ + "static/media/grants-pass.69f857a4.webp";